import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Stack, Typography, IconButton, Divider, Tabs, Tab, } from "@mui/material";
import FileOptions from "../FileOptions";
import { useStoreFileViewerContext } from "../../hooks/context";
import StoreFileDetails from "./StoreFileDetails";
import StoreFileSharing from "./StoreFileSharing";
import { PREVIEW_FILE_WIDTH } from "./constants";
import { alertOnError } from "../AlertSnackbar/hooks";
import StoreObjectIcon from "../StoreObjectIcon";
var PreviewStoreFile = function (_a) {
    var _b, _c, _d;
    var data = _a.data, onClose = _a.onClose;
    var _e = useStoreFileViewerContext(), apiRef = _e.apiRef, reload = _e.reload;
    var _f = useState("sharing"), currentTab = _f[0], setCurrentTab = _f[1];
    var handleTabChange = function (event, newTabId) {
        setCurrentTab(newTabId);
    };
    var _g = useState(data), object = _g[0], setObject = _g[1];
    useEffect(function () {
        if (!data.id || !apiRef.get)
            return;
        apiRef
            .get({ id: data.id })
            .then(function (response) {
            var _a, _b;
            if (response.status === "Success") {
                setObject(__assign(__assign({}, response.result.object), (((_a = response.result) === null || _a === void 0 ? void 0 : _a.dest_url) && {
                    dest_url: (_b = response.result) === null || _b === void 0 ? void 0 : _b.dest_url,
                })));
            }
        })
            .catch(function (err) {
            alertOnError(err);
            reload();
        });
    }, [data.id]);
    useEffect(function () {
        if (!!data.id) {
            setObject(function (state) { return (__assign(__assign({}, state), data)); });
        }
    }, [data]);
    var mimeType = (_c = ((_b = object.name) !== null && _b !== void 0 ? _b : "").split(".").at(-1)) !== null && _c !== void 0 ? _c : "";
    return (_jsxs(Stack, { width: "".concat(PREVIEW_FILE_WIDTH, "px"), padding: 1, spacing: 1, paddingLeft: 2, paddingRight: 2, "data-testid": "Preview-Panel", height: "100%", children: [_jsxs(Stack, { direction: "row", alignItems: "center", children: [_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [_jsx(StoreObjectIcon, { type: "", mimeType: mimeType, password: !!(object === null || object === void 0 ? void 0 : object["vault-password-algorithm"]) ||
                                    !!((_d = object === null || object === void 0 ? void 0 : object.metadata_protected) === null || _d === void 0 ? void 0 : _d["vault-password-algorithm"]) }), _jsx(Typography, { variant: "subtitle1", sx: { overflow: "hidden", wordBreak: "break-all", fontWeight: 400 }, children: object.name })] }), _jsxs(Stack, { direction: "row", alignItems: "center", sx: { marginLeft: "auto!important" }, spacing: 1, children: [_jsx(FileOptions, { object: object, onClose: function () { } }), _jsx(IconButton, { onClick: onClose, children: _jsx(CloseIcon, { fontSize: "small" }) })] })] }), _jsx(Divider, { sx: { marginLeft: "-16px!important", marginRight: "-16px!important" } }), _jsxs(Tabs, { value: currentTab, onChange: handleTabChange, children: [_jsx(Tab, { value: "details", id: "details", label: "Details", sx: { width: "50%", minHeight: "50px" } }), _jsx(Tab, { value: "sharing", id: "sharing", label: "Sharing", sx: { width: "50%", minHeight: "50px" } })] }), currentTab === "details" && (_jsx(StoreFileDetails, { object: object, onClose: onClose })), currentTab === "sharing" && (_jsx(StoreFileSharing, { object: object, onClose: onClose }))] }));
};
export default PreviewStoreFile;
